import React from 'react';

function App() {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-6xl md:text-8xl font-bold mb-8 text-white">
          XLEGION
        </h1>
        
        <div className="text-2xl md:text-4xl mb-6 text-purple-400">
          TBA
        </div>
        
        <div className="text-lg text-gray-400 font-mono">
          www.xlegion.io
        </div>
      </div>
    </div>
  );
}

export default App;